import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

import { Stepper } from 'src/app/core/models/properties';
import { StepperService } from 'src/app/core/services/step-service/stepper.service';
@Component({
  selector: 'app-step',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss']
})
export class StepperComponent implements OnInit {

  @Input() type = 1;

  @Input()
  public listStepper: Stepper[] = [];

  @Input()
  public stepperData = [];

  @Output()
  public sendStepper = new EventEmitter<Stepper>();
  @Output()
  public sendData = new EventEmitter<any>();

  @Output()
  public sendStepperList = new EventEmitter<any>();

  public indexList: number [] = [];


  constructor(
    private stepperService: StepperService,
  ) { }

  ngOnInit(): void {
    this.stepperService.getList().subscribe(x => this.stepperData = x);
    this.progressStepper();
  }

  public progressStepper() {
    let index = 0;
    const inter = setInterval(() => {
      if (index >= this.listStepper.length) {
        clearInterval(inter);
        return false;
      }
      if (this.listStepper[index].completed) {
        index += 1;
        this.indexList.push(index);
      }
      this.clearInterval(index, inter);
    }, 600);
  }

  private clearInterval(index: number, variableName) {
    if (this.listStepper[index] && !this.listStepper[index].completed) {
      clearInterval(variableName);
    }
  }

}
